"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Notification = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _react = _interopRequireDefault(require("react"));
var _index = _interopRequireDefault(require("./RcNotification/index"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _ykbUtils = require("ykb-utils");
var _Button = _interopRequireDefault(require("../Button"));
var _excluded = ["message", "duration", "onClose", "action", "bordered"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var notificationInstance = {};
var defaultConfig = {
  duration: 3,
  placement: 'topCenter',
  style: {},
  closable: true
};
// dumpy named export for props.table on stylegudist
var Notification = exports.Notification = function Notification(props) {
  return null;
};
function getNotificationInstance(_x, _x2) {
  return _getNotificationInstance.apply(this, arguments);
}
function _getNotificationInstance() {
  _getNotificationInstance = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee(options, callback) {
    var placement;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          placement = options.placement;
          if (!notificationInstance[placement]) {
            _context.next = 3;
            break;
          }
          return _context.abrupt("return", callback(notificationInstance[placement]));
        case 3:
          _context.next = 5;
          return _index.default.newInstance({
            className: "".concat(placement),
            style: {},
            getContainer: _ykbUtils.containerChecker
          }, function (notification) {
            notificationInstance[placement] = notification;
            return callback(notification);
          });
        case 5:
          return _context.abrupt("return", _context.sent);
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _getNotificationInstance.apply(this, arguments);
}
function renderNotificationContent(args) {
  var _args$action, _args$action2, _args$action3, _args$action4, _args$action5;
  var cls = (0, _classnames.default)((0, _defineProperty2.default)({}, "notification-notice-with-icon", args.icon));
  var iconNode = null;
  if (args.icon) {
    iconNode = /*#__PURE__*/_react.default.createElement("div", {
      className: "notification-notice-icon"
    }, args.icon);
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: cls
  }, iconNode, /*#__PURE__*/_react.default.createElement("div", {
    className: "notification-notice-header-message-wrapper"
  }, args.header && /*#__PURE__*/_react.default.createElement("div", {
    className: "notification-notice-header"
  }, " ", args.header), args.message && /*#__PURE__*/_react.default.createElement("div", {
    className: "notification-notice-message"
  }, " ", args.message), args.action && ((_args$action = args.action) !== null && _args$action !== void 0 && _args$action.button ? (_args$action2 = args.action) === null || _args$action2 === void 0 ? void 0 : _args$action2.button : /*#__PURE__*/_react.default.createElement(_Button.default, (0, _extends2.default)({}, (_args$action3 = args.action) === null || _args$action3 === void 0 ? void 0 : _args$action3.props, {
    onClick: (_args$action4 = args.action) === null || _args$action4 === void 0 ? void 0 : _args$action4.handler,
    className: "notification-notice-action"
  }), (_args$action5 = args.action) === null || _args$action5 === void 0 ? void 0 : _args$action5.text))));
}
function notice(args) {
  var options = _objectSpread(_objectSpread({}, defaultConfig), args);
  return getNotificationInstance(options, function (notification) {
    var key = notification.notice(_objectSpread(_objectSpread({}, options), {}, {
      closeIcon: /*#__PURE__*/_react.default.createElement(_Icon.default, {
        name: "close",
        size: 24
      }),
      className: [options.type ? "notification-".concat(options.type) : '', options.header ? 'with-title' : '', options.bordered ? 'bordered' : '', options.action ? 'with-action' : ''].join(' '),
      content: renderNotificationContent(options)
    }));
    return function () {
      notification.removeNotice(key);
    };
  });
}
function findTemplateFromErrorType(type, title) {
  var notificationData = null;
  switch (type) {
    case 'info':
      notificationData = {
        icon: /*#__PURE__*/_react.default.createElement(_Icon.default, {
          name: "info-circle"
        })
      };
      break;
    case 'success':
      notificationData = {
        icon: /*#__PURE__*/_react.default.createElement(_Icon.default, {
          name: "check-circle"
        })
      };
      break;
    case 'warning':
      notificationData = {
        icon: /*#__PURE__*/_react.default.createElement(_Icon.default, {
          name: "warning-circle"
        })
      };
      break;
    case 'error':
      notificationData = {
        icon: /*#__PURE__*/_react.default.createElement(_Icon.default, {
          name: "close-circle"
        })
      };
      break;
    default:
      notificationData = null;
  }
  return notificationData;
}
function adjustParams(params, data) {
  var title = params.title,
    icon = params.icon;
  if (title) {
    data['header'] = title;
  }
  if (icon) {
    data['icon'] = icon;
  }
  return data;
}
var notificationObj = {
  notify: function notify(args) {
    return notice(args);
  }
};
var methods = ['info', 'success', 'error', 'warning'];
methods.forEach(function (type) {
  notificationObj[type] = function (message, duration, onClose) {
    var itemAdditionalData = findTemplateFromErrorType(type);
    if ((0, _typeof2.default)(message) == 'object') {
      var _message = message.message,
        _duration = message.duration,
        _onClose = message.onClose,
        action = message.action,
        bordered = message.bordered,
        rest = (0, _objectWithoutProperties2.default)(message, _excluded);
      itemAdditionalData = adjustParams(rest, itemAdditionalData);
      return notice(_objectSpread({
        message: _message,
        duration: _duration,
        onClose: _onClose,
        type: type,
        action: action,
        bordered: bordered
      }, itemAdditionalData));
    } else {
      return notice(_objectSpread({
        message: message,
        duration: duration,
        onClose: onClose,
        type: type
      }, itemAdditionalData));
    }
  };
});
var _default = exports.default = notificationObj;